import { CartSettings, InjectedCartProps, withCart as withCartFactory } from '@grandvisionhq/next'

export const settings: CartSettings = {
  isDiscountCodeEnabled: true,
  showCartDiscountOnLineItem: true,
  showSubTotal: true,
  showTotalDiscount: true,
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
